
import JSData from 'js-data';
import { JsDataRestAdapter } from './jsDataRestAdapter';
import {
  IAdapterRegistrationFunction, IResourceDefinitionMap, IJsDataRestStoreConstructorOptions, IRestResourceDefinition, IRestResourceOptions,
} from './types';

/**
 * Declare inherited members via interface/class declaration merging so they
 * stay on the prototype. Declaring them as class fields would emit
 * `this.defineResource = void 0` after `super()` under define-class-fields
 * semantics, shadowing the `defineResource` method inherited from JSData.DS
 * (causing "this.defineResource is not a function") and wiping `definitions`.
 */
export interface JsDataRestStore {
  definitions: IResourceDefinitionMap;
  registerAdapter: IAdapterRegistrationFunction;
}

/**
 * This class is a extension of JSData DS(data store)
 * @param {object} restfulService - (required) a wrapper of ajax request
 */
// eslint-disable-next-line no-redeclare
export class JsDataRestStore extends JSData.DS {
  constructor({ restfulService }: IJsDataRestStoreConstructorOptions) {
    super();

    this.registerAdapter('rest', new JsDataRestAdapter({ restfulService }), { default: true });
  }

  /**
   * Define resource using JSData data store
   * @param {string} resourceName - (required) the name of resource
   * @param {object} uriPath - (required) the default uri path for each resource
   * @param {string} primaryKey - (optional) the primary key for the resource, default is 'id'
   *
   * @returns {object} the JsData resource
   */
  defineRestResource(
    resourceName: string,
    { uriPath, primaryKey = 'id' }: IRestResourceOptions
  ): IRestResourceDefinition {
    if (this.definitions && this.definitions[resourceName]) {
      return this.definitions[resourceName];
    }
    return this.defineResource({
      name: resourceName,
      meta: { uriPath },
      idAttribute: primaryKey,
    }) as IRestResourceDefinition;
  }
}
